<template>
  <div class="chartsData" ref="chartsData"></div>
</template>

<script>
export default {
    name:'Fanchart',
    methods:{
        getCharts(){
            let _this = this;
            this.chartsData = this.$echarts.init(this.$refs.chartsData);
            let option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    textStyle: {
                        color: "#fff"
                    },
                    left: "84%",
                    top: "40%"
                },
                series: [
                    {
                        name: '故障统计',
                        type: 'pie',
                        // roseType: 'area',
                        radius: '50%',
                        right:'20%',
                        data: [
                            {value: 580, name: '故障A'},
                            {value: 484, name: '故障B'},
                            {value: 300, name: '故障C'}
                        ],
                        label:{
                            color: "#fff",
                            fontFamily: "Source Han Sans CN"
                        },
                        // emphasis: {
                        //     itemStyle: {
                        //         shadowBlur: 10,
                        //         shadowOffsetX: 0,
                        //         shadowColor: 'rgba(0, 0, 0, 0.5)',
                        //     }
                        // },
                        itemStyle:{
                            normal: {
                                borderWidth:1,
                                borderColor: "#00C0FF",
                                color: function(params) {
                                    var colorList = [
                                {
                                    c1: 'rgba(0, 192, 255, 0.5)',
                                    c2: 'rgba(0, 192, 255, 0)'                                                                   
                                },
                                {
                                    c1: '#00C0FF', 
                                    c2: '#FCFF00'
                                },
                                {
                                    c1: '#00C0FF',
                                    c2: '#0084FF'
                                }]
                                    return new _this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上

                                        offset: 0,
                                        color: colorList[params.dataIndex].c1
                                    }, {
                                        offset: 1,
                                        color: colorList[params.dataIndex].c2
                                    }])                                    
                                }
                            }
                        }
                    }
                ]
            };
            this.chartsData.setOption(option);
        }
    },
    mounted(){
        this.getCharts()
    }
}
</script>

<style langg='scss' scoped>
.chartsData{
    width: 100%;
    height: 400px;
}
</style>